import React, { useEffect, useState } from "react";
import NewsItems from './NewsItems';
import Spinner from './Spinner';
import PropTypes from 'prop-types';
import InfiniteScroll from "react-infinite-scroll-component";
import { Helmet } from 'react-helmet';
const News = (props) => {
    const [articles, setArticles] = useState([]);
    const [page, setPage] = useState(1);
    const [totalResults, setTotalResults] = useState(0);
    const [pageSize, setPageSize] = useState(6);
    const [firstScroll, setFirstScroll] = useState(false);

    const Capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const updateNews = async () => {
        //let url = 'http://localhost/test/getnews.php';
        let url = 'https://news.g1tech.in/getnews.php';
        let data = {
            country: props.country,
            category: props.category,
            apiKey: props.apiKey,
            page: page,
            pageSize: 6
        };

        let options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        try {
            let newsData = await fetch(url, options);
            let parsedData = await newsData.json();
            setArticles(articles.concat(parsedData));
            setTotalResults(parsedData.totalResults);
            props.setProgress(100);
        } catch (error) {
            console.error('Error fetching news data:', error);
        }
    }

    useEffect(() => {
        document.title = Capitalize(props.category) + " - G1News";
        updateNews();
    }, []);

    const fetchMoreData = async () => {
        setPage(page + 1)
        console.log('pagepage',page)
        if(page >= 1){
            setFirstScroll(true);
        }
        await updateNews();
    }

    return (
        <>
        {<Helmet>
            <meta name="description" content={props.category} />
            <meta name="keywords" content={props.category.split(' ').join(', ')} />
        </Helmet>}
        <h2 className='text-center' style={{ margin: '10px' }}>Top Headlines - {Capitalize(props.category)}</h2>
            <InfiniteScroll
                dataLength={articles.length}
                next={fetchMoreData}
                hasMore={totalResults !== articles.length}
                loader={<Spinner />}
            >
                <div className="container">
                    <div className="row">
                    {firstScroll && (
                        <div id="container-15db4941c0aa41b3a99b0096bf46b15c"></div>
                    )}
                    {articles.map((element, index) => {
                        console.log('element',element);
                        return (
                            <div className="col-md-4" key={element.url}>
                                <NewsItems
                                    key={`news_${element.id}`} 
                                    category={element.category} 
                                    title={element.title} 
                                    description={element.description} 
                                    imageUrl={!element.urlToImage ? "https://cdn.ndtv.com/common/images/ogndtv.png" : element.urlToImage} 
                                    newsUrl={element.url} 
                                    updateDate={element.updateDate} 
                                    auther={element.auther} 
                                    source={element.source} 
                                    id={element.id} 
                                />
                            </div>
                        );
                    })}
                    </div>
                </div>
            </InfiniteScroll>
        </>
    )
}

News.defaultProps = {
    country: 'in',
    category: 'sport',
    pageSize: 6
}

News.propTypes = {
    country: PropTypes.string,
    category: PropTypes.string,
    pageSize: PropTypes.number
}

export default News;
